import React , {useRef , useEffect , useState} from "react";
import {
    View,
    ScrollView,
    Dimensions,
    StyleSheet,
    Image,
    Text,
    Pressable,
    Platform,
    TouchableOpacity
} from "react-native";
import * as Linking from 'expo-linking';
import {RFValue} from "react-native-responsive-fontsize";
import Dot from "../Components/Dot";

import Config from "../../Config";
import {Entypo} from "@expo/vector-icons";


let sliderwidth = 25;
let marginslider = 10;

import {useFocusEffect} from "@react-navigation/native";


const SliderHome2 = ({slider, navigation})=>{


    const scrollRef = useRef();
    const count = slider.length;


    let scrollSize = Dimensions.get('window').width * count;
    let windowsize = Dimensions.get('window').width ;

    let [size,setSize] = useState(0);
    let [counter,setCounter] = useState(0);
    let [reset,setReset] = useState(0);



    let [focused,setFocused] = React.useState(true);


    useFocusEffect(
        React.useCallback(()=>{
            setFocused(true);
            return ()=>{
                setFocused(false);
            }
        },[])
    );



    //first start
    useEffect(()=>{
            setCounter(0);
            scrollRef.current.scrollTo({x: (0), y: 0});
        },
        []
    );




    const Redirect = (navigation , item)=>{
        //0 web
        //1 category
        //2 course
        //3 word
        //4 placement

        // Linking.openURL(item.target);

        if(item.type == 0){
            Linking.openURL(item.target);
        }

        if(item.type == 4){
            navigation.navigate("placement");
        }
        if(item.type == 3){
            navigation.navigate("Words");
        }

        if(item.type == 2){
            navigation.navigate("Course",{course_id:item.target});
        }
        if(item.type == 1){
            navigation.navigate("Category",{category_id:item.target});
        }

    }


    let result = 0;

    if(counter == 0){
        result = 0;
    }else{
        // result = (windowsize - sliderwidth ) * counter - (sliderwidth / 2);
        result = (windowsize - sliderwidth + (marginslider * 2) ) * counter  ;
        result = result  - (sliderwidth/2 ) + marginslider;
    }






    //slider change
    useEffect(()=>{
            const fn = setInterval(() => {

                if(counter == (count -1 )){
                    setCounter(0)
                    setReset(prevState => prevState + 1);
                    scrollRef.current.scrollTo({x: 0,  y: 0});
                }else{
                    setCounter(prevState => prevState + 1)
                }
                // alert(size);
            }, 8000);
            return () => {
                clearInterval(fn);
            };
        },
        [reset,counter]
    );

    const next = ()=>{
        if(counter == (count -1 )){
            setCounter(0)
            setReset(prevState => prevState + 1);
            scrollRef.current.scrollTo({x: 0,  y: 0});
        }else{
            setCounter(prevState => prevState + 1)
        }
    }
    const prev = ()=>{
        if(counter != 0){
            setCounter(prevState => prevState - 1)
        }else{
            setCounter(3)
        }
    }


    const handleScroll = (e) => {
        if(Platform.OS === 'web'){
            setTimeout(() => {
                result = e.nativeEvent.contentOffset.x;
                const newcounter = Math.round(result / (windowsize - sliderwidth + (marginslider * 2)));
                setCounter(newcounter);
            }, 350); // تاخیر برای تشخیص توقف اسکرول
        }
    };


    if(focused){
        //fix bug exam ?
        setTimeout(()=>{
            // console.log(result , counter ,'x,counter');
            scrollRef.current.scrollTo({x: result,  y: 0});
        },500)
    }




    return (
        <>
            <View style={styles.main}>
                <ScrollView
                    style={{direction : 'ltr'}}
                    horizontal={true}
                    showsVerticalScrollIndicator ={false}
                    showsHorizontalScrollIndicator={false}
                    pagingEnabled={true}
                    ref={ scrollRef}
                    // contentOffset={{x: 5, y: 0}}
                    scrollEnabled={true}

                    // onMomentumScrollEnd={e => console.log(e.nativeEvent.contentOffset , e.nativeEvent.layoutMeasurement)}
                    onMomentumScrollEnd={e =>{
                        // setSize(e.nativeEvent.contentOffset.x)
                        result = e.nativeEvent.contentOffset.x;
                        const newcounter = Math.round(result / (windowsize - sliderwidth + (marginslider * 2)));
                        setCounter(newcounter);
                    }}
                    onScroll={handleScroll}


                    // onMomentumScrollEnd={e => console.log(e.nativeEvent.contentSize.width)}


                >

                    {slider.map(  (item,index)=> (
                        <Pressable onPress={()=>Redirect(navigation,item)} key={index} style={styles.slider}>
                            <Image
                                resizeMode={'stretch'}
                                fadeDuration={999}
                                style={styles.img}
                                source={{uri :  Config.base +'/'+item.image}}
                            />
                        </Pressable>
                    ) )}
                </ScrollView>
                <View style={styles.rowdot}>


                    <>
                        <TouchableOpacity onPress={()=>setCounter(0)}  >
                            <Dot full={ counter == 0 ? 1 : 0 }/>
                        </TouchableOpacity  >
                        <TouchableOpacity  onPress={()=>setCounter(1)}  >
                            <Dot full={ counter == 1 ? 1 : 0 }/>
                        </TouchableOpacity>
                        <TouchableOpacity  onPress={()=>setCounter(2)}  >
                            <Dot full={ counter == 2 ? 1 : 0 }/>
                        </TouchableOpacity>
                        <TouchableOpacity  onPress={()=>setCounter(3)}  >
                            <Dot full={ counter == 3 ? 1 : 0 }/>
                        </TouchableOpacity>
                    </>
                </View>
                {/*<View style={*/}
                {/*    {*/}
                {/*        flexDirection : 'row',*/}
                {/*        justifyContent : 'space-between',*/}
                {/*        width:'100%' ,*/}
                {/*        paddingHorizontal : RFValue(10),*/}
                {/*        // backgroundColor:'red',*/}
                {/*        position: 'absolute',*/}
                {/*        top : RFValue(75),*/}
                {/*        zIndex:9999*/}

                {/*    }*/}
                {/*}>*/}
                {/*    <Entypo onPress={()=>prev()} name="chevron-thin-left" size={RFValue(45)} color={Config.secondcolor} />*/}
                {/*    <Entypo onPress={()=>{next()}} name="chevron-thin-right" size={RFValue(45)} color={Config.secondcolor} />*/}
                {/*</View>*/}

            </View>

        </>
    );

}
const styles = StyleSheet.create({
    main : {
        // flex : 1,
        // backgroundColor:'gray'
        direction : 'ltr'
    },
    img : {
        width : Dimensions.get('window').width  - sliderwidth ,
        height : RFValue(210) ,
        borderRadius : RFValue(20)
    } ,

    img2 : {
        width : Dimensions.get('window').width  - sliderwidth ,
        height : RFValue(110) ,
        borderRadius : RFValue(20)
    } ,
    slider : {
        width : Dimensions.get('window').width - sliderwidth   ,
        // width : 392.727 ,

        justifyContent:"center",
        alignItems:"center",
        marginTop:RFValue(4),
        marginBottom:RFValue(20),

        marginHorizontal: marginslider,
    },

    rowdot : {
        flexDirection: 'row',
        justifyContent: "center",
        alignItems: "center"
    }
});


export default SliderHome2;